import React from 'react';
import {
    ClusterNumberFieldEdit,
} from '@domain/dashboard/cluster/campaign-table-cluster-components/cluster-number-field-edit';
import { CLUSTER_FIELDS_FUNCTIONS } from '@domain/dashboard/cluster/cluster.constants';
import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';

interface PaceBudgetEdit {
    value: number
    row: any
}

export const PaceBudgetEdit = ({
    value,
    row,
}: PaceBudgetEdit) => (
    <ClusterNumberFieldEdit
        row={row}
        value={value}
        key={CLUSTER_FIELDS_FUNCTIONS.paceBudget.field}
        field={CLUSTER_FIELDS_FUNCTIONS.paceBudget.field}
        type={METRICS_TYPES.percent}
        suffix=" %"
        precision={0}
    />
);
